import classnames from "classnames";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import "./LocationTransitionWrapper.scss";

export type Props = {
  children: ReactNode;
  centerVertically?: boolean;
  className?: string;
  location?: any;
};

export default function LocationTransitionWrapper({
  children,
  centerVertically,
  className
}: Props) {
  const location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        classNames="LocationTransitionWrapper"
        timeout={400}
        mountOnEnter
        unmountOnExit
      >
        <div
          className={classnames("LocationTransitionWrapper", className, {
            "LocationTransitionWrapper--centered": centerVertically
          })}
        >
          {children}
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}
